import axios from 'axios'

export const editDiscount = async (discount: any) => {
  const response = await axios.put('/data/atlaide/' + discount.id, discount)

  return response.data
}
